<template>
  <svg width="142" height="126" viewBox="0 0 142 126" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M38.9038 48.5312L58.2163 26" stroke="#CCCCCC" stroke-width="5" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M103.279 48.5312L83.9663 26" stroke="#CCCCCC" stroke-width="5" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M100.858 100.031H41.3243C39.9305 100.006 38.586 99.5107 37.5087 98.6258C36.4315 97.741 35.6845
    96.5183 35.3889 95.1559L26.2133 56.5309C25.9677 55.6059 25.9337 54.6373 26.1139 53.6973C26.294 52.7573
    26.6838 51.87 27.2541 51.1014C27.8244 50.3327 28.5606 49.7025 29.408 49.2575C30.2554 48.8126 31.1922 48.5643
    32.1487 48.5312H110.034C110.99 48.5643 111.927 48.8126 112.775 49.2575C113.622 49.7025 114.358 50.3327 114.929
    51.1014C115.499 51.87 115.889 52.7573 116.069 53.6973C116.249 54.6373 116.215 55.6059 115.969 56.5309L106.794
    95.1559C106.498 96.5183 105.751 97.741 104.674 98.6258C103.597 99.5107 102.252 100.006 100.858 100.031V100.031Z"
          stroke="#CCCCCC" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M51.7788 61.4062V87.1562" stroke="#CCCCCC" stroke-width="5" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M71.0913 61.4062V87.1562" stroke="#CCCCCC" stroke-width="5" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M90.4038 61.4062V87.1562" stroke="#CCCCCC" stroke-width="5" stroke-linecap="round"
          stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'IconCart',
};
</script>

<style scoped>

</style>
